import { useCallback } from "react";
var useScrollToAnchor = function useScrollToAnchor(anchor) {
  var scrollToAnchor = useCallback(function () {
    if (!anchor) {
      return;
    }
    var element = document.getElementById(anchor.replace("#", ""));
    if (!element) {
      return;
    }
    element.scrollIntoView({
      behavior: "smooth"
    });
  }, [anchor]);
  return scrollToAnchor;
};
export default useScrollToAnchor;